module.exports = __webpack_public_path__ + "img/snowfon.38238c88.png";